// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xZM7pHyqxSjiqJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2px;
  padding-bottom: 2px;
}
.SwJc0NvpTPcBrE {
  margin: 0;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: 600;
  line-height: 28px;
}
.TEvqlv2vcinu0_ {
  margin-bottom: 0;
}
.TEvqlv2vcinu0_:hover,
.TEvqlv2vcinu0_:active {
  background-color: transparent;
}
.aTRnIWYi7l3CE3 {
  transition: transform 0.2s ease-out;
}
.aTRnIWYi7l3CE3.NwPuZRUIKhVT0l {
  transform: rotate(180deg);
}
.qjbbzNjvSmnmvj {
  height: auto;
}
.qjbbzNjvSmnmvj.NwPuZRUIKhVT0l {
  height: 0;
  overflow: hidden;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `xZM7pHyqxSjiqJ`,
	"title": `SwJc0NvpTPcBrE`,
	"button": `TEvqlv2vcinu0_`,
	"icon": `aTRnIWYi7l3CE3`,
	"collapsed": `NwPuZRUIKhVT0l`,
	"content": `qjbbzNjvSmnmvj`
};
export default ___CSS_LOADER_EXPORT___;
